export default {
  'sequence.title': 'Gestionar Secuencias',
  'sequence.pattern': 'Patrón',
  'sequence.pattern.list.currentDay': 'Día Actual - ',
  'sequence.pattern.list.currentMonthNumber': 'Número Mes Actual - ',
  'sequence.pattern.list.currentYear': 'Año Actual - ',
  'sequence.pattern.list.currentYearOnlyLastTwoDigits': 'Año Actual Solo 2 últimos dígitos - ',
  'sequence.pattern.list.automaticNumbering': 'Numeración Automática - ',
  'sequence.pattern.list.automaticNumberingRestartYearly':
    'Numeración Automática(Reinicio Anual) - ',
  'sequence.pattern.list.automaticNumberingRestartMonthly':
    'Numeración Automática(Reinicio Mensual) - ',
  'sequence.pattern.list.automaticNumberingRestartDaily':
    'Numeración Automática(Reinicio Diario) - ',
  'sequence.pattern.list.processName': 'Nombre Proceso - ',
  'sequence.pattern.list.processGroupName': 'Nombre Grupo de Proceso - ',
  'sequence.pattern.list.applicantFullName': 'Solicitante (Nombre Completo) - ',
  'sequence.pattern.list.applicantNames': 'Solicitante (Nombres) - ',
  'sequence.pattern.list.applicantLastNames': 'Solicitante (Apellidos) - ',
  'sequence.pattern.list.applicantPosition': 'Puesto Solicitante - ',
  'sequence.pattern.list.note':
    'Nota: Debe reemplazar #D con un número válido. Ejemplo, si desea usar {`{ACNI#D}`} debe escribir {`{ACNI#4}`} donde el número 4 serían la cantidad de dígitos que tendrá la numeración (0001,0002,..0045)',
  'sequence.pattern.list.formInternalNameFieldInternalName':
    '{{Form.nombre_interno_formulario.Field.nombre_interno_campo}}',
  'sequence.pattern.list.variableName': '{{Variable.nombre_variable}}',
  'sequence.pattern.list.entityEntityIdItemItemIdFieldInternalName':
    '{{Entity.entity_id.Item.item_id.Field.internal_name}}',
  'sequence.pattern.list.iterationStepDataFieldInternalName':
    '{{IterationStep.Data.nombre_interno_campo}}',
  'sequence.automaticNumbersCurrentYear': 'Año Actual - Numeración Automática',
  'sequence.automaticNumbersCurrentMonth': 'Mes Actual - Numeración Automática',
  'sequence.automaticNumbersCurrentDay': 'Día Actual - Numeración Automática',
  'sequence.lastGeneratedNumber': 'Último Número Generado',
  'sequence.rowVersion': 'Row Version',
  'sequence.creator': 'Creador',
  'sequence.modifier': 'Modificador',
  'sequence.sequenceItem': 'Sub Secuencia',
  'sequence.generatedNumber': 'Número Generado',
  'sequence.referenceItemId': 'ID Elemento Referencia',
  'sequence.referenceItemDescription': 'Descripción Elemento Referencia',
  'sequence.referenceExtraData': 'Datos Extra Referencia',
};
